import { render, staticRenderFns } from "./TransportDialog.vue?vue&type=template&id=2007e9e8&scoped=true"
import script from "./TransportDialog.vue?vue&type=script&lang=js"
export * from "./TransportDialog.vue?vue&type=script&lang=js"
import style0 from "./TransportDialog.vue?vue&type=style&index=0&id=2007e9e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2007e9e8",
  null
  
)

export default component.exports